import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Pricing from './pages/Pricing';
import BillingSuccess from './pages/BillingSuccess';
import UltraAdminLogin from './pages/UltraAdminLogin';
import UltraAdminDashboard from './pages/UltraAdminDashboard';
import UltraAdminPanel from './pages/admin/UltraAdminPanel';
import OrganizerDashboard from './pages/OrganizerDashboard';
import CompanyDashboard from './pages/CompanyDashboard';
import SetPassword from './pages/SetPassword';
import ExpoMap from './pages/ExpoMap';
import { Toaster } from './components/ui/sonner';
import ErrorBoundary from './components/ErrorBoundary';

export const AuthContext = React.createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setUser(res.data);
        setLoading(false);
      })
      .catch(() => {
        localStorage.removeItem('token');
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Yükleniyor...</div>;
  }

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            {/* Landing page */}
            <Route path="/" element={!user ? <LandingPage /> : (
              user.role === 'ultra_admin' ? <Navigate to="/ultra-admin/panel" /> :
              (user.role === 'organizer' || user.role === 'team_member') ? <Navigate to="/organizer" /> :
              <Navigate to="/company" />
            )} />
            
            {/* Public routes */}
            <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
            <Route path="/register" element={!user ? <Register /> : <Navigate to="/pricing" />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/expo/:exhibitionId/map" element={<ExpoMap />} />
            <Route path="/billing/success" element={user ? <BillingSuccess /> : <Navigate to="/login" />} />
            <Route path="/ultra-admin/login" element={!user ? <UltraAdminLogin /> : <Navigate to="/ultra-admin/panel" />} />
            
            {/* Ultra Admin routes */}
            <Route path="/ultra-admin" element={
              user?.role === 'ultra_admin' ? <Navigate to="/ultra-admin/panel" /> : <Navigate to="/ultra-admin/login" />
            } />
            <Route path="/ultra-admin/panel/*" element={
              user?.role === 'ultra_admin' ? <UltraAdminPanel /> : <Navigate to="/ultra-admin/login" />
            } />
            
            {/* Legacy ultra admin dashboard */}
            <Route path="/ultra-admin-old" element={
              user?.role === 'ultra_admin' ? <UltraAdminDashboard /> : <Navigate to="/login" />
            } />
            
            {/* Organizer routes */}
            <Route path="/organizer/*" element={
              (user?.role === 'organizer' || user?.role === 'team_member') ? <OrganizerDashboard /> : <Navigate to="/login" />
            } />
            
            {/* Company routes */}
            <Route path="/company" element={
              user?.role === 'company' ? <CompanyDashboard /> : <Navigate to="/login" />
            } />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-right" />
    </AuthContext.Provider>
  );
}

export default App;
export { API };